export default "assets/images/icons/wines-462e5685.svg";